import React from "react";
import { useTableContext } from "../../components/AdministrateTable";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { EditFeeScheduleByPayorModal } from "./EditFeeScheduleByPayorModal";
import { useDestroyPermission, useUpdatePermission } from "../../utils";
import { History } from "../../tools/sandbox/release/History";

export const LabFeeScheduleByPayorActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("CptFeeSchedule", row.original.id);
  const [canUpdate] = useUpdatePermission("CptFeeSchedule", row.original.id);

  const handleChange = (msg) => {
    setMessage(`Updated Cpt Fee Schedule By By ${row.original.payor.name} for CPT Code  ${row.original.cptCode.code}`);
    refresh();
  };

  return (
    <>
      {canUpdate && <EditFeeScheduleByPayorModal color="link" onEdit={handleChange} feeSchedule={row.original} />}
      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/cpt_fee_schedules/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Cpt Fee Schedule By ${row.original.payor.name} for CPT Code  ${row.original.cptCode.code}`);
          }}
          onError={(msg) => setError(msg)}
        />
      )}
      <History entityName="CptFeeSchedule" subjectId={row.original.id} />
    </>
  );
};
